import React, { Component } from 'react'
import { I18n } from 'react-i18next'
import Button from './Button'
import ColorPicker from './ColorPicker'

class ColorMenu extends Component {
  constructor (props) {
    super(props)

    this.state = {
      ornamentBackground: 'black'
    }

    this.setOrnamentBg = this.setOrnamentBg.bind(this)
  }

  setOrnamentBg (event) {
    const ornamentBg = event.target.value
    this.setState({
      ornamentBackground: ornamentBg
    },
    // Simulate a click to update the handle
    () => this.props.onClick({
      target: {
        value: JSON.stringify(this.props.colors.find(c => {
          return (
            c.ornament === this.props.color.ornament &&
            c.ornament_color === this.props.color.ornament_color &&
            c.color === ornamentBg
          )
        }))
      }
    }))
  }

  render () {
    let colorComps = []
    let ornamentBackgroundSelector

    switch (this.props.colors[0].color_type) {
      case 'decor':
      case 'custom':
        // First of all : black or white ?
        ornamentBackgroundSelector =
          <I18n key='ornamentBgSelector'>
            {(t, { i18n }) => (
              <div className='configurator-button-group'>
                <Button
                  className={this.state.ornamentBackground === 'black' ? 'active' : ''}
                  onClick={this.setOrnamentBg}
                  value='black'
                >{t('configurator.color.black')}</Button>
                <Button
                  className={this.state.ornamentBackground === 'white' ? 'active' : ''}
                  onClick={this.setOrnamentBg}
                  value='white'
                >{t('configurator.color.white')}</Button>
              </div>
            )}
          </I18n>

        // Then the colors
        Array.from(
          new Set(this.props.colors.map(col => col.ornament_category))
        ).forEach(category => {
          // Category title
          if (this.props.colors[0].color_type === 'decor') {
            colorComps.push(
              <h4 key={category}>{category}</h4>
            )
          }

          // Actual colors (without declinable versions)
          colorComps.push(
            <ColorPicker
              key={category + '-picker'}
              colors={
                this.props.colors.filter(
                  col => {
                    return (
                      col.ornament_category === category &&
                      col.ornament_color === null &&
                      col.color === this.state.ornamentBackground
                    )
                  }
                ).map(col => {
                  if (typeof col.customDesign === 'undefined') {
                    // Getting ornament texture for each ornament
                    const asset = require('../assets/images/thumbs/' +
                      this.props.colors[0].color_type + 's/' + col.ornament + '.png')
                    col.css = {
                      backgroundColor: '#333',
                      backgroundImage: 'url(\'' + asset + '\')',
                      backgroundSize: 'cover'
                    }

                    // If ornament is declinable
                    col.declinable = false
                    if (this.props.colors.find((c, i) => {
                      return (c.ornament === col.ornament && c.ornament_color !== null)
                    })) {
                      col.declinable = true
                      col.image_file = this.props.colors.find(c => (c.ornament === col.ornament && c.ornament_color === '13' && c.color === col.color)).image_file
                    }
                  }

                  return col
                })
              }
              activeLayer={this.props.color.image_file}
              onClick={this.props.onClick}
              hideLabel={this.props.colors[0].color_type === 'custom'}
            />
          )
        })

        // And the upload button
        if (this.props.colors[0].color_type === 'custom') {
          colorComps.push(
            <I18n key='ornamentBgSelector'>
              {(t, { i18n }) => (
                <button className='configurator-red-button' onClick={this.props.customize}>
                  {t('configurator.createYourOwnButton')}
                </button>
              )}
            </I18n>
          )
        }
        break

      default:
        colorComps.push(
          <ColorPicker
            key='single-color-picker'
            colors={
              this.props.colors.map(col => {
                col.css = { background: col.color_css }
                return col
              })
            }
            activeLayer={this.props.color.image_file}
            onClick={this.props.onClick}
          />
        )
        break
    }

    return [
      ornamentBackgroundSelector,
      <div className='configurator-colors' key='confColors'>{colorComps}</div>
    ]
  }
}

export default ColorMenu



// WEBPACK FOOTER //
// ./src/components/ColorMenu.js